import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
  }

  submitForm = e => {
    this.element.querySelector('form').requestSubmit();
  }
}
